export default __webpack_public_path__ + "static/media/cost_pl.ab0363ed.png";